import { HomeScreen } from "./types";
import { stringF, object } from "./helpers";

export const homeScreen = object<HomeScreen>({
  backgroundImage: stringF("Not Visible?")
});
